import {Box} from '@mui/material';
import EmployeesList from './employees-list';
import {CompanyUser} from '@/types/user';
import {useCompanyContext} from '@/contexts/admin/companies';

interface EmployeesPanelProps {
  companyEmployees?: CompanyUser[] | null;
  companyId: string;
  companiesDashboardMode?: boolean;
}

const EmployeesPanel: React.FC<EmployeesPanelProps> = ({
  companyEmployees,
  companyId,
  companiesDashboardMode
}) => {
  const companyContext = useCompanyContext();

  const mainCompanyEmployees = companyContext?.companyEmployees || [];

  const employees = companyEmployees ? companyEmployees : mainCompanyEmployees;

  return (
    <Box marginTop={4}>
      {employees && (
        <EmployeesList
          employees={employees}
          companyId={companyId}
          companiesDashboardMode={companiesDashboardMode}
        />
      )}
    </Box>
  );
};

export default EmployeesPanel;
